// extracted by mini-css-extract-plugin
export default {"Pin":"Pin_Pin__QgEfV","hoverOverlay":"Pin_hoverOverlay__yM-Qc","hoverOverlayActive":"Pin_hoverOverlayActive__tI8yK","additional":"Pin_additional__Y-aFd","main":"Pin_main__0t04U"};